var RestrictionsDecorate = require('../../../../facade/restrictions/decorate');

module.exports = RestrictionsDecorate({
  haveOptions: function (selection) {
    var restrictionsFacade = require('../../../../facade/restrictions/restrictions');
    var getRestrictions = _.partial(
      restrictionsFacade.getElementRestrictions,
      selection.id
    );

    return getRestrictions('source').length ||
      getRestrictions('colors').length ||
      getRestrictions('colors-library').length;
  }
}, { haveOptions: function () { return false; } });
